import React from 'react';
import { TrustBar } from './TrustBar';
import { AccidentsHappen } from './AccidentsHappen';
import { Services } from './Services';
import { RepairOrReplace } from './RepairOrReplace';
import { SideDoorRear } from './SideDoorRear';
import { TruckGlass } from './TruckGlass';
import { ADAS } from './ADAS';
import { Insurance } from './Insurance';
import { Process } from './Process';
import { Locations } from './Locations';
import { AutoGlassFAQ } from '../../components/AutoGlassFAQ/AutoGlassFAQ';
import { ServiceReview } from '../../../components/PageIntro';
export function AutoGlassRepair() {
  return <div className="legacy-sections" data-id="element-486" data-mp="260c4s7nm1g6n">
<TrustBar data-id="element-487" data-mp="2602e0huqr4zw" />
<AccidentsHappen data-id="element-488" data-mp="25zapfqzka7j4" />
<Services data-id="element-489" data-mp="25yrckoorq9by" />
<ServiceReview index={0} data-id="element-490" data-mp="2arkdt2l12zja" />
<RepairOrReplace data-id="element-491" data-mp="2as3tsdr4bduo" />
<SideDoorRear data-id="element-492" data-mp="2aslyzzvrd2eq" />
<TruckGlass data-id="element-493" data-mp="2at58cs7ceih5" />
<ADAS data-id="element-494" data-mp="2atorudcn5exa" />
<Insurance data-id="element-495" data-mp="2atf0omfv11q0" />
<Process data-id="element-496" data-mp="1e9o38ui0y8sg" />
<Locations data-id="element-497" data-mp="1e9xu0kaw8jz7" />
<AutoGlassFAQ data-id="element-498" data-mp="1eahfgazr5qhz" />
</div>;
}